import { writeStorage, useLocalStorage } from '@rehooks/local-storage';
import React from 'react';
import * as Icon from 'react-feather';

import {
    Button as AlchemyButton,
    RadioButtons as AlchemyRadioButtons,
    Tooltip as AlchemyTooltip,
} from "@amzn/alchemy-components-react";

import {LocalStorageType} from "../enums";
import i18n from "../i18n";

export default function() {
    const [currentLanguage, setCurrentLanguage] = useLocalStorage<any>(`${LocalStorageType.UserLanguage}`, "en");

    const languageOptions = [
        {label: "English", value: "en"},
        {label: "French", value: "fr"},
        // {label: "简体中文", value: "cn"},
        // {label: "German", value: "de"},
    ];

    const onLanguageChange = (ev) => {
        setCurrentLanguage(ev.target.value)
        location.reload();
    }

    return <AlchemyTooltip variant="popover">
        <span slot="trigger">
            <AlchemyButton className="button-transparent" size="sm">
                <div className="d-flex">
                    <Icon.Globe size={16} />&nbsp;
                    {languageOptions.find(({value}) => value === currentLanguage).label} ({currentLanguage})
                </div>
            </AlchemyButton>
        </span>
        <div>
            <div className="alert-inline alert-inline-warning mb-1">{i18n.t('language-selector:note')}</div>
            <AlchemyRadioButtons
                name="group-name"
                buttons={languageOptions}
                onChange={onLanguageChange}
                value={currentLanguage}
            ></AlchemyRadioButtons>
        </div>
    </AlchemyTooltip>
}